import React from "react";
import PageHero from "../components/PageHero";
import { company } from "../mock";

export default function TermsOfService() {
  return (
    <main>
      <PageHero
        eyebrow="Legal"
        title="Terms of Service"
        subtitle="Terms that apply to the use of our website and consultancy services."
        breadcrumb={[{ label: "Terms of Service" }]}
      />

      <section className="py-16 md:py-20">
        <div className="container-x max-w-4xl">
          <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
            <p className="text-sm text-slate-500">Last updated: 2026</p>

            <h2 className="text-2xl font-bold text-navy mt-8">1. About these terms</h2>
            <p>
              These Terms of Service apply to the use of the website operated by {company.legalName} and to consultancy
              services provided by Apex Quality Consultancy. By using our website or engaging our services, you agree
              to these terms.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">2. Our services</h2>
            <p>
              Apex Quality Consultancy provides NDIS compliance consultancy, documentation, audit readiness, internal
              audit, corrective action and ongoing compliance support. We do not act as the independent external
              Approved Quality Auditor for providers we have consulted to.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">3. Engagement and quotes</h2>
            <p>
              Quotes are based on standard scope and comparable inclusions. Final pricing may vary depending on
              registration groups, modules, number of sites, participant files, staff files, urgency, provider
              complexity and implementation needs. Services commence once a written proposal or invoice has been
              accepted by the client.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">4. Payment</h2>
            <p>
              Invoices are payable in accordance with the payment terms stated on the invoice. Late payment may delay
              delivery of documentation or services. External fees (Approved Quality Auditor fees, insurance, worker
              screening, ASIC, government and third party fees) are payable directly by the client.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">5. No guarantee of outcome</h2>
            <p>
              Apex Quality Consultancy does not guarantee NDIS registration, audit approval, audit outcomes,
              participant referrals or client numbers. Audit and registration outcomes depend on the provider’s
              implementation, staff qualifications, evidence, business operations, participant records, application
              accuracy and auditor assessment.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">6. Documentation Quality Commitment</h2>
            <p>
              Eligible written deliverables are backed by our Documentation Quality Commitment. If any major
              compliance issues arise directly due to documentation we have supplied, we will work with the client to
              correct and resolve the issue at no additional cost. Full conditions are outlined on our Quality
              Commitment page.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">7. Intellectual property</h2>
            <p>
              All website content, documentation templates and written deliverables prepared by Apex Quality
              Consultancy remain our intellectual property. Clients receive a licence to use deliverables for their
              own NDIS provider operations only. Resale, redistribution or unauthorised sharing is not permitted.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">8. General information only</h2>
            <p>
              Information provided by Apex Quality Consultancy is general consultancy and compliance preparation
              support only. It is not legal, financial, accounting or insurance advice. Providers should obtain
              independent professional advice where required.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">9. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, our liability for any claim relating to our services is limited
              to the fees paid for the specific deliverable giving rise to the claim. Nothing in these terms excludes,
              restricts or modifies rights under the Australian Consumer Law that cannot lawfully be excluded.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">10. Governing law</h2>
            <p>
              These Terms are governed by the laws of Victoria, Australia, and the parties submit to the jurisdiction
              of the courts of Victoria.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">11. Contact us</h2>
            <p>
              For questions about these terms, contact us at
              {' '}<a href={`mailto:${company.email}`} className="text-teal underline">{company.email}</a>.
            </p>

            <div className="mt-10 p-5 bg-mist rounded-xl border border-slate-200 text-sm">
              <p className="font-semibold text-navy">{company.legalName}</p>
              <p>ABN: {company.abn} | ACN: {company.acn}</p>
              <p>{company.address}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
